import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .Mui-error": {
      color: "orange",
    },
    "& .MuiFormHelperText-root": {
      color: "orange",
    },
  },
}));

export default useStyles;
